import { facetParamsToPath } from '@//utils/vehicles-search/utils';

export const pathPrettifier =
  (searchPage: string) =>
  (data: Record<string, string>): string => {
    const params = new URLSearchParams(data);
    const prettyPath = facetParamsToPath(params);
    return `${searchPage}${prettyPath ? `/${prettyPath}` : `?${params}`}`;
  };
